import { Box, Img, Text } from '@chakra-ui/react';
import emergency from '../../assets/Group 67.svg';
import CustomModal from '../../components/CustomModal';
import EmergencyModal from './components/EmergencyModal';

const Emergency = () => {
  return (
    <Box>
      <CustomModal buttonProps={{ ...btnProps }} btnTitle={<EmergencyIcon />}>
        <EmergencyModal />
      </CustomModal>
    </Box>
  );
};

export default Emergency;

const btnProps = { bg: 'transparent', p: '1' };

const EmergencyIcon = () => {
  return (
    <Box>
      <Img
        pos='relative'
        bottom='-4'
        left='1'
        src={emergency}
        alt='emergnecy'
      />
      ;
      <Text m='0 !important' fontSize='10px' color='#aaa'>
        Emergency
      </Text>
    </Box>
  );
};
